import { createIdentityBackSvg, createIdentityFrontSvg, identityArtworkMetadata } from "../merch/artwork/identityArtwork";
import { downloadSvg, exportSvgToPng } from "./merchArtworkExport";

export async function downloadAllIdentityProductionFiles({ onProgress } = {}) {
  const variants = [
    { placement: "front", tone: "dark", create: createIdentityFrontSvg },
    { placement: "front", tone: "light", create: createIdentityFrontSvg },
    { placement: "back", tone: "dark", create: createIdentityBackSvg },
    { placement: "back", tone: "light", create: createIdentityBackSvg }
  ];
  const failures = [];
  let completed = 0;
  for (const variant of variants) {
    const svgString = variant.create({ garmentTone: variant.tone });
    const metadata = identityArtworkMetadata[variant.placement];
    for (const format of ["svg", "png"]) {
      try {
        if (format === "svg") downloadSvg(svgString, metadata.filenames[variant.tone]);
        else await exportSvgToPng({ svgString, filename: metadata.pngFilenames[variant.tone], width: identityArtworkMetadata.width, height: identityArtworkMetadata.height });
      } catch (error) {
        failures.push({ filename: format === "svg" ? metadata.filenames[variant.tone] : metadata.pngFilenames[variant.tone], error });
      }
      completed += 1;
      onProgress?.(completed, 8);
      await new Promise((resolve) => setTimeout(resolve, 120));
    }
  }
  return failures;
}
